import React from "react";
import {
  Flex,
  IconButton,
  Spacer,
  Stack,
  Divider,
  VStack,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  FlexProps
} from "@chakra-ui/react";
import { IoArrowForward } from "react-icons/io5";
import { useOnline, useAuth } from "duck";
import { getMenu } from "../../duck";
import NavLink from "../nav-link";
import Sidebar from "../sidebar";

const MobileSidebar: React.FC<FlexProps> = props => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  const online = useOnline();
  const [{ user }] = useAuth();

  return (
    <>
      <Flex backgroundColor="#0B0C10" direction="column" {...props}>
        <Stack as="nav" aria-label="Sidebar navigation" px="2" spacing="0.5">
          <VStack spacing="0.813rem" pt={8} mb="1.375rem">
            <IconButton
              ref={btnRef.current}
              aria-label="Expand sidebar"
              variant="unstyled"
              color="gray.200"
              display="flex"
              icon={<IoArrowForward fontSize="1.625rem" />}
              onClick={onOpen}
            />
            <Divider borderColor="gray.200" borderBottomWidth="2px" />
          </VStack>
          {getMenu(online, user.userRole).map(menuItem => (
            <NavLink
              key={menuItem.key}
              size="sm"
              label={menuItem.key}
              to={menuItem.to}
              icon={menuItem.icon}
            />
          ))}
        </Stack>
        <Spacer />
      </Flex>
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        finalFocusRef={btnRef.current}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerBody p={0}>
            <Sidebar h="100vh" navSize="lg" onClose={onClose} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default MobileSidebar;
